export interface Store {
  code: number;
  name: string;
  channel: string;
}

export interface User {
  name: string;
  cpf: string;
  personId: number;
  channels: string[];
  cpId: number;
  role: string;
  club?: string;
  isFirstAccess?: boolean;
  stores: Store[];
}

export const emptyUser: User = {
  name: '',
  cpf: '',
  personId: 0,
  channels: [],
  cpId: 0,
  role: '',
  stores: [],
};
